import { render, staticRenderFns } from "./SitePolls.vue?vue&type=template&id=4901623d&"
import script from "./SitePolls.vue?vue&type=script&lang=js&"
export * from "./SitePolls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports